
import { z } from "zod";

export const BillTypeValues = ["ADJUSTER", "BILLABLE_CHANGE_ORDER", "CONTRACTOR", "DISPUTE", "DUMPSTER", "MATERIALS", "NON_BILLABLE_CHANGE_ORDER", "PERMIT"] as const;
export const BillTypeSchema = /* @__PURE__ */ z.enum(BillTypeValues);
export const BillType: (typeof BillTypeSchema)["enum"] = { "ADJUSTER": "ADJUSTER", "BILLABLE_CHANGE_ORDER": "BILLABLE_CHANGE_ORDER", "CONTRACTOR": "CONTRACTOR", "DISPUTE": "DISPUTE", "DUMPSTER": "DUMPSTER", "MATERIALS": "MATERIALS", "NON_BILLABLE_CHANGE_ORDER": "NON_BILLABLE_CHANGE_ORDER", "PERMIT": "PERMIT" };
export type BillType = (typeof BillTypeValues)[number];
export const BillTypeDisplayNames = { "ADJUSTER": "Adjuster",
"BILLABLE_CHANGE_ORDER": "Billable change order",
"CONTRACTOR": "Work order",
"DISPUTE": "Dispute",
"DUMPSTER": "Dumpster",
"MATERIALS": "Materials",
"NON_BILLABLE_CHANGE_ORDER": "Non-billable change order",
"PERMIT": "Permit", } satisfies Record<BillType, string>;
